// ============================================================================
// WebHID Compatibility Detection
// ============================================================================

/**
 * Check if the WebHID API is available in the current browser.
 */
export function isWebHIDSupported(): boolean {
  return typeof navigator !== 'undefined' && 'hid' in navigator;
}

/**
 * Get a human-readable reason why WebHID is not supported.
 * Returns null if WebHID IS supported.
 */
export function getWebHIDUnsupportedReason(): string | null {
  if (typeof navigator === 'undefined') {
    return 'Not running in a browser environment.';
  }
  if (!('hid' in navigator)) {
    return 'WebHID is not supported in this browser. Please use Chrome 89+ or Edge 89+.';
  }
  if (location.protocol !== 'https:' && location.hostname !== 'localhost') {
    return 'WebHID requires a secure context (HTTPS or localhost).';
  }
  return null;
}
